import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy, map } from 'lodash';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl, menuToggler } from '@bd/bdcore-utilities';
import withStyles, { css } from '@bd/bdui-styles';
import LightBox from '@bd/bdui-lightbox';
import HomeCard from '../../components/HomeCard';
// import LotCard from '../../components/LotCard';
import PlanCard from '../../components/PlanCard';
import CommunityCardVertical from '../../components/CommunityCardVertical';
import PageSectionHeading from '../../components/PageSectionHeading';
import FavoriteToggle from './FavoriteToggle';

const defaultStyles = css``;

const videoBoxStyle = css`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  text-align: center;
  width: 80%;
  padding-top: 45%;
  position: relative;
  margin: 0 auto;
  align-items: center;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    right:0;
    bottom:0;
    width:100%;
    height:100%;
  }
`;

const categories = {
  home: {
    title: 'Homes',
    render: (favorite, { homes }) => {
      const home = homes.find(h => h._id === favorite.favoriteId);

      if (!home) {
        return null;
      }

      return (
        <div key={home._id}>
          <HomeCard home={home} favorite={favorite} />
        </div>
      );
    },
  },
  lot: {
    title: 'Lots',
    render: (favorite, { lots }) => {
      const lot = lots.find(l => l._id === favorite.favoriteId);

      if (!lot) {
        return null;
      }
      return (
        <div key={lot._id} className="col-12 p-0">
          {/* <LotCard lot={lot} favorite={favorite} /> */}
        </div>
      );
    },
  },
  plan: {
    title: 'Floor Plans',
    render: (favorite, { plans }) => {
      const plan = plans.find(p => p._id === favorite.favoriteId);

      if (!plan) {
        return null;
      }

      return (
        <div key={plan._id}>
          <PlanCard plan={plan} favorite={favorite} />
        </div>
      );
    },
  },
  community: {
    title: 'Communities',
    render: (favorite, { communities }) => {
      const community = communities.find(c => c._id === favorite.favoriteId);

      if (!community) {
        return null;
      }

      return (
        <div key={community._id}>
          <CommunityCardVertical community={community} favorite={favorite} />
        </div>
      );
    },
  },
  content: {
    title: 'Other Items',
  },
  upload: {
    title: 'Uploads',
    alwaysShow: true,
    allow: ({ user }) => !!user,
  },
};

function FavoritesCategories(props) {
  const { activateMenu, isActiveMenu, favorites, className } = props;
  return (
    <div className={className}>
      <div className="">
        <span role="button" tabIndex="0" className="PageMenu_title" onClick={() => activateMenu('favorite')}>Favorites</span>
        <ul className={`PageMenu_list ${isActiveMenu('favorite') ? 'open' : ''}`}>
          {
            map(categories, (category, key) => (
              <li className="PageMenu_listItem" key={key}>
                <span role="button" tabIndex={0}>
                  <strong>{`${category.title}`}</strong> {`${favorites.filter(f => f.type === key).length}`}
                </span>
              </li>
            ))
          }
        </ul>
        {
          map(categories, (category, key) => {
            const items = favorites.filter(f => f.type === key);
            if (['content', 'upload'].includes(key) || items.length === 0) {
              return null;
            }
            return (
              <div key={key}>
                <PageSectionHeading h2={category.title} />
                <div className={`Cards_Wrap Cards_Wrap-${key}`}>
                  {
                    orderBy(items, 'favoritedAt', 'desc')
                      .map(favorite => category.render(favorite, props))
                  }
                </div>
              </div>
            );
          })
        }
        {
          map(categories, (category, key) => {
            if (!['content', 'upload'].includes(key)) {
              return null;
            }

            return (
              <LightBox
                key={key}
                items={orderBy(favorites.filter(f => f.type === key), 'favoritedAt', 'desc').map(favorite => {
                  if (favorite.iframe) {
                    return {
                      element: (
                        <div className={videoBoxStyle}>
                          <iframe src={favorite.favoriteId} title={favorite.favoriteId} />
                        </div>
                      ),
                    };
                  }
                  return favorite;
                })}
                onlyWithIndex
              >
                <ul className="VideoGallery_List list-unstyled row m-0 justify-content-center">
                  {
                    orderBy(favorites.filter(f => f.type === key), 'favoritedAt', 'desc').map((favorite, index) => (
                      <li className="col-12 col-sm-6 p-0 col-xl-4" key={favorite._id}>
                        <div className="FavoriteCardWrap" data-index={index}>
                          {/* <YoutubeThumbnail
                            video={_.get('video', video)}
                            index={i}
                          /> */}
                          {/* <img src={_.get('thumbnail_preview.contentUrl', video)} alt="" /> */}
                          {/* <img src={buildThumbnailUrl(get(video, 'thumbnail_preview.contentUrl')
                          , { height: 450, width: 800, exact: true })} data-index={i} alt="" /> */}
                          <div className="PhotoCard" style={{ backgroundImage: `url(${buildThumbnailUrl(get(favorite, 'image.contentUrl', get(favorite, 'image.imageUrl')), { width: 800, height: 450, exact: true })})` }} />
                          <div className="Favorite_circle">
                            <FavoriteToggle
                              favorite={favorite}
                            />
                          </div>
                          {
                            favorite.iframe &&
                            <div className="PlayIcon" >
                              <div className="PlayIcon_triangle" />
                            </div>
                          }
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </LightBox>
            );
          })
        }
      </div>
    </div>
  );
}

FavoritesCategories.propTypes = {
  activateMenu: PropTypes.func.isRequired,
  isActiveMenu: PropTypes.func.isRequired,
  className: PropTypes.string,
  // home: PropTypes.object,
  // plan: PropTypes.object,
  // community: PropTypes.object,
  // content: PropTypes.object,
  favorites: PropTypes.arrayOf(PropTypes.object),
};

FavoritesCategories.defaultProps = {
  className: '',
  // home: undefined,
  // plan: undefined,
  // community: undefined,
  // content: undefined,
  favorites: [],
};

export default withData(
  {
    favorites: true,
    homes: true,
    communities: true,
    plans: true,
    lots: true,
  },
  {
    required: {},
  },
)(withStyles(defaultStyles)(menuToggler(FavoritesCategories)));



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/Favorites/FavoritesCategories.js